<app-edit-layout-content 
    [layoutsetting]="layoutsetting"
    (drop)="drop($event)"
    (updateFieldsOrders)="updateFieldsOrders($event)"
    (removeFieldFromCustomBox)="removeFieldFromCustomBox($event)"
    (addFieldsInCustomBox)="addFieldsInCustomBox($event)"
    (renameCustomBox)="updateCustomBoxName($event)"
    (createCustomBox)="createCustomBox()"
    (closeModal)="closeSidebar.emit()"
    (removeCustomBox)="removeCustomBox($event)"
    [metaDataItems]="metaDataItems$ | async"
    [loading]="updateLayoutSettingsRequestState$ | async"
    (updateVisibility)="updateVisibility($event)"
    (updateLayoutSettings)="updateLayoutSettings()"
></app-edit-layout-content>
